import type { JSX } from 'react'

import { TextBoxCaption4Secondary } from 'atoms/TextBox/Templates'
import { PromoTextSC } from '../Footer.styled'

export interface IPromoText {
  promoText?: string
  dataTestId?: string
}

export const PromoText = ({
  promoText,
  dataTestId = '',
}: IPromoText): JSX.Element | null => {
  return promoText ? (
    <PromoTextSC data-testid={dataTestId}>
      <TextBoxCaption4Secondary title={promoText} />
    </PromoTextSC>
  ) : null
}
